import logger from "@plat-components/utils2/_esm5/logger";

function goToSpace(mid: string) {
  logger("gotospace_" + mid);
  setTimeout(() => {
    if (mid) {
      window.open(`https://space.bilibili.com/${mid}/dynamic`);
    }
  }, 50);
}

export default goToSpace;
